"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaBuilder = void 0;
const logger_1 = require("../../../util/logger");
class MediaBuilder {
    constructor(trackProvider, roomWall) {
        this.trackProvider = trackProvider;
        this.roomWall = roomWall;
        this.log = logger_1.logger.extend('sdk:media_builder');
    }
    createMedia(config) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.trackProvider.createMediaStream(config);
            if (result.audio) {
                this.roomWall.addOrUpdate(this.roomWall.builder.buildTrackWallItem('audioTrack', {
                    active: null,
                    name: (_a = config.audio) === null || _a === void 0 ? void 0 : _a.name,
                }));
                this.log.info(`Media of type audio created with name: ${(_b = config.audio) === null || _b === void 0 ? void 0 : _b.name}`);
            }
            if (result.video) {
                this.roomWall.addOrUpdate(this.roomWall.builder.buildTrackWallItem('videoTrack', {
                    cameraSubject: (_c = config.video) === null || _c === void 0 ? void 0 : _c.cameraSubject,
                    name: (_d = config.video) === null || _d === void 0 ? void 0 : _d.name,
                    active: (_e = config.video) === null || _e === void 0 ? void 0 : _e.active,
                }));
                this.log.info(`Media of type video created with name: ${(_f = config.video) === null || _f === void 0 ? void 0 : _f.name}`);
            }
            if (result.data) {
                this.roomWall.addOrUpdate(this.roomWall.builder.buildTrackWallItem('dataTrack', {
                    name: (_g = config.data) === null || _g === void 0 ? void 0 : _g.name,
                }));
                this.log.info(`Media of type data created with name: ${(_h = config.data) === null || _h === void 0 ? void 0 : _h.name}`);
            }
        });
    }
}
exports.MediaBuilder = MediaBuilder;
//# sourceMappingURL=media_builder.js.map